// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { AnyAction } from "../actions/actionCreators";
import { IApplicationState } from "../../models/applicationState";
import initialState from "../store/initialState";
import combineReducers from "./index";

/**
 * App Error Reducer
 * Actions handled:
 *  SHOW_ERROR
 *  CLEAR_ERROR
 * @param {IAppError} state
 * @param {AnyAction} action
 * @returns {any}
 */
export const reducer = (state: IApplicationState[] = [], action: AnyAction) => {
    switch (action.type) {
        case ActionTypes.LOGGED_OUT_USER:
            return action.payload;
        default:
            return state;
    }
};
